import { FC } from 'react';
import { Modal, ModalOverlay } from '@chakra-ui/react';
import { EditHookReturnType } from '../../types';
import { REGISTRATION_STEP } from '../../../../../constants/registrationStep';
import { EnvironmentRegistrationInputModalView } from './EnvironmentRegistrationInputModalView';
import { EnvironmentRegistrationConfirmModalView } from './EnvironmentRegistrationConfirmModalView';
import { EnvironmentRegistrationResultModalView } from './EnvironmentRegistrationResultModalView';

type Props = EditHookReturnType;

export const EnvironmentRegistrationModalView: FC<Props> = ({
  isOpenModal,
  onCloseModal,
  onCloseModalWhenCompleted,
  currentModalStep,
  form,
  values,
  onConfirm,
  onGoBack,
  onSubmit,
  onOpenModalDelete,
  mode,
  onAppend,
  onRemove,
  controlledFields,
  componentList,
}) => (
  <Modal
    isOpen={isOpenModal}
    onClose={onCloseModal}
    size="4xl"
    blockScrollOnMount
    closeOnOverlayClick={false}
    closeOnEsc={false}
  >
    <ModalOverlay />
    {currentModalStep === REGISTRATION_STEP.INPUT && (
      <EnvironmentRegistrationInputModalView
        mode={mode}
        {...form}
        handleConfirm={onConfirm}
        onOpenModalDelete={onOpenModalDelete}
        onAppend={onAppend}
        onRemove={onRemove}
        controlledFields={controlledFields}
        componentList={componentList}
      />
    )}
    {currentModalStep === REGISTRATION_STEP.CONFIRMATION && (
      <EnvironmentRegistrationConfirmModalView
        mode={mode}
        values={values}
        handleBack={onGoBack}
        handleSubmit={onSubmit}
        componentList={componentList}
      />
    )}
    {currentModalStep === REGISTRATION_STEP.RESULT && (
      <EnvironmentRegistrationResultModalView
        mode={mode}
        values={values}
        handleClose={onCloseModalWhenCompleted}
        componentList={componentList}
      />
    )}
  </Modal>
);
